var r={Success:"success",Warning:"warning",Error:"error",Neutral:"neutral",Feature:"feature"},s={Status:"status",Emphasis:"emphasis"};export{r as HighlightType,s as HighlightVariant};
//# sourceMappingURL=types.js.map
